import { isEmpty } from 'lodash-es';
import './../../shop/modules/multi_checkout/services.multi-checkout';
import './../../shop/modules/services.saved.stores';
import './../../shop/modules/services.pnotify';
import { DESTINATION_TYPES } from './constants/destinationType';
import { CHECKOUT_EVENTS } from '../../shop/constants/angular-events';
import { CART_STEPS } from './constants/multi-checkout';

const DESTINATION_TYPE_MAP = {
  seven_eleven_store_type: DESTINATION_TYPES.SAVE_STORE_MAP_7_11,
  family_mart_store_type: DESTINATION_TYPES.SAVE_STORE_MAP_FAMILY_MART,
};

app.directive('destinationSectionSaveStore', [
  'savedStoresService',
  'pnotifyService',
  'multiCheckoutService',
  '$filter',
  function (savedStoresService, pnotifyService, multiCheckoutService, $filter) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.save-store.html'),
      scope: {
        store: '=',
        userStores: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
        storeType: '@',
      },
      link: function (scope) {
        scope.state = {
          tempStore: {},
          selectedOption: scope.userStores[0]._id,
          defaultStore: scope.store,
        };

        function getFullStore(storeObject) {
          const { location_code, location_name, store_address } = storeObject;
          return `${location_code}.${location_name}.${store_address}`;
        }

        scope.setUserStore = (userStore) => {
          scope.store = userStore;
        };

        scope.removeStore = (store) => {
          savedStoresService
            .removeStore({
              userId: store.user_id,
              type: store.type,
              locationCode: store.delivery_data.location_code,
            })
            .then(() => {
              scope.userStores = scope.userStores.filter(
                (userStore) => userStore._id !== store._id,
              );

              // selectedOption is only needed when there are user stores.
              // If all stores are deleted, the user must select a new store, and selectedOption is no longer needed.
              if (
                scope.state.selectedOption === store._id &&
                scope.userStores.length > 0
              ) {
                scope.state.selectedOption = scope.userStores[0]._id;
                scope.store = scope.userStores[0];
              }

              if (scope.userStores.length === 0) {
                scope.store = {};
              }
            })
            .catch(() => {
              pnotifyService.notify(
                $filter('translate')('saved_stores.update.failure'),
                {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                },
              );
            });
        };

        scope.$watch('state.selectedOption', function (newVal, oldVal) {
          if (newVal === oldVal) return;

          if (newVal === 'new') {
            scope.store = scope.state.tempStore;
          }
        });

        scope.$watch('state.defaultStore', function (newVal) {
          if (isEmpty(newVal)) {
            scope.store = scope.userStores[0];
            return;
          }

          // Indicates that the API multi_cart_destination has delivery_data in the deliveries object
          const isUpdatedStore = !('delivery_data' in newVal);
          const storeData = isUpdatedStore ? newVal : newVal.delivery_data;
          const storeString = getFullStore(storeData);
          const store = scope.userStores.find((savedStore) => {
            const savedStoreString = getFullStore(savedStore.delivery_data);
            return storeString === savedStoreString;
          });

          if (store) {
            scope.state.selectedOption = store._id;
            scope.store = store;
            return;
          }

          scope.state.selectedOption = 'new';
          scope.state.tempStore = newVal;
          scope.store = newVal;
        });

        // trigger tracker event only when user arrive at destination section
        scope.$on(CHECKOUT_EVENTS.CART.STEP.NEXT, (_, { nextStep }) => {
          if (
            nextStep !== CART_STEPS.DESTINATION ||
            scope.state.selectedOption === 'new'
          ) {
            return;
          }

          multiCheckoutService.trackFillRecipientData(
            DESTINATION_TYPE_MAP[scope.storeType],
          );
        });
      },
    };
  },
]);
